"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconTimeClockFileEdit = /*#__PURE__*/
function (_Icon) {
  _inherits(IconTimeClockFileEdit, _Icon);
  function IconTimeClockFileEdit(props) {
    var _this;
    _classCallCheck(this, IconTimeClockFileEdit);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconTimeClockFileEdit).call(this, props));
    _this.name = 'IconTimeClockFileEdit';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "time-clock-file-edit_svg__group0"
    }, _react2.default.createElement("path", {
      className: "time-clock-file-edit_svg__path0",
      d: "M1.5 24C.673 24 0 23.327 0 22.5v-21C0 .673.673 0 1.5 0h13.293c.401.001.778.157 1.061.441l3.706 3.706c.284.282.44.659.44 1.06V8.5a.5.5 0 01-1 0V5.207a.494.494 0 00-.147-.353l-3.707-3.706A.495.495 0 0014.793 1H1.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h7a.5.5 0 010 1h-7z"
    }), _react2.default.createElement("path", {
      className: "time-clock-file-edit_svg__path1",
      d: "M9.5 16.001a5.506 5.506 0 01-5.5-5.5c0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zm0-10c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
    }), _react2.default.createElement("path", {
      className: "time-clock-file-edit_svg__path2",
      d: "M9.5 11.001a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v2.5h1.5a.5.5 0 010 1h-2z"
    }), _react2.default.createElement("path", {
      className: "time-clock-file-edit_svg__path3",
      d: "M11.5 24.001a.5.5 0 01-.491-.598l.75-3.75a.495.495 0 01.137-.255l7.63-7.631a2.598 2.598 0 011.849-.765 2.602 2.602 0 011.876.793A2.56 2.56 0 0124 13.622c0 .698-.271 1.354-.764 1.848l-7.633 7.634a.502.502 0 01-.255.137l-3.751.75a.457.457 0 01-.097.01zm.638-1.137l2.866-.573 7.523-7.524c.307-.307.474-.713.474-1.143a1.6 1.6 0 00-.495-1.163A1.582 1.582 0 0021.38 12c-.434 0-.841.168-1.147.473l-7.523 7.524-.572 2.867z"
    })));
    return _this;
  }
  return IconTimeClockFileEdit;
}(_Icon3.default);
exports.default = IconTimeClockFileEdit;